import React, { FC, useState } from 'react';
import { TextField, Typography } from '@mui/material';
import { useAuth } from '../../contexts/AuthContext';
import { AuthForm } from '../../components/Auth/AuthForm';
import { Link, useSearchParams } from 'react-router-dom';

export const GuestResetPasswordPage: FC = () => {
  const { requestPasswordReset, resetPassword, error } = useAuth();
  const [searchParams] = useSearchParams();
  const resetToken = searchParams.get('reset_password_token');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [passwordConfirmation, setPasswordConfirmation] = useState('');
  const [isRequestSent, setIsRequestSent] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (resetToken) {
      await resetPassword(password, passwordConfirmation, resetToken);
    } else {
      await requestPasswordReset(email);
      setIsRequestSent(true);
    }
  };

  if (isRequestSent) {
    return (
      <AuthForm title="Check Your Email" onSubmit={() => {}} submitLabel="">
        <Typography align="center">
          We've sent password reset instructions to your email address. Please
          check your inbox and follow the link to reset your password.
        </Typography>
        <Typography variant="body2">
          <Link to="/?auth=login">Back to Sign In</Link>
        </Typography>
      </AuthForm>
    );
  }

  return (
    <AuthForm
      title={resetToken ? 'Reset Password' : 'Forgot Password'}
      onSubmit={handleSubmit}
      submitLabel={resetToken ? 'Reset Password' : 'Send Reset Instructions'}
      error={error}
    >
      {resetToken ? (
        <>
          <TextField
            label="New Password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            fullWidth
            autoComplete="new-password"
            helperText="Must be at least 6 characters"
          />
          <TextField
            label="Confirm New Password"
            type="password"
            value={passwordConfirmation}
            onChange={(e) => setPasswordConfirmation(e.target.value)}
            required
            fullWidth
            autoComplete="new-password"
          />
        </>
      ) : (
        <>
          <TextField
            label="Email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            autoComplete="email"
            helperText="Enter the email address you used to sign up"
          />

          <Typography variant="body2">
            <Link to="/?auth=login">Back to Sign In</Link>
          </Typography>
        </>
      )}
    </AuthForm>
  );
};
